const LoadingSpinner = () => {
  return (
    <div 
      className="min-h-screen flex flex-col items-center justify-center bg-warm-cream"
      role="status"
      aria-label="Loading content"
    >
      <div className="spinner mb-4"></div>
      <p className="text-rich-mahogany font-crimson text-lg">
        Loading...
      </p>
    </div>
  )
}

export default LoadingSpinner
